export { default as ProductsAiSearchImage } from './ProductsAiSearchImage';
